import { render, staticRenderFns } from "./FileBottomBar.vue?vue&type=template&id=72a05f28&"
import script from "./FileBottomBar.vue?vue&type=script&lang=js&"
export * from "./FileBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./FileBottomBar.vue?vue&type=style&index=0&id=72a05f28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports